import React from "react";
import "./styles.css";

export const Badge = ({ variant = "default", className = "", ...props }) => {
  return (
    <div
      className={`custom-signal-com-required-badge custom-signal-com-required-badge-${variant} ${className}`}
      {...props}
    />
  );
};